import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { customAuthAxios } from '../../utils/customAuthAxios';
import { useSuccessToast } from '../toast/useSuccessToast';


export const useEditStaff = (staffId: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const onSubmit = useCallback(async (data: any) => {
    try {
      const uploadData = new FormData();
      uploadData.append("name", data.name);
      uploadData.append("nickname", data.nickname);
      data.img[0] && uploadData.append("img", data.img[0], data.img[0].name);
      await customAuthAxios.put(
        `restaurant_staff/staff/${staffId}/`,
        uploadData
      );
      showToast('スタッフを編集しました')
      navigate(-1)
    } catch (error:any) {
    }
  }, [navigate, showToast]);
  return onSubmit;
};